<template>
  <div class="pagination-wrapper">
    <div
      class="pagination-prev"
      :class="{ disabled: props.currentItem === 1 }"
      @click="changePage(props.currentItem - 1)"
    >
      <i class="bi bi-chevron-left" />
    </div>
    <div class="pagination-pages">
      <div
        v-for="page in pagesToDisplay"
        :key="page"
        class="pagination-item"
        :class="{ current: props.currentItem === page }"
        @click="changePage(page)"
        v-text="page"
      />
    </div>
    <div
      class="pagination-next"
      :class="{ disabled: props.currentItem === props.nbPages }"
      @click="changePage(props.currentItem + 1)"
    >
      <i class="bi bi-chevron-right" />
    </div>
  </div>
</template>

<script setup>
import { computed, reactive } from "vue";

const emits = defineEmits(["changePage"]);

const state = reactive({
  maxItem: 5,
});

const props = defineProps({
  currentItem: {
    type: Number,
    required: true,
  },
  nbPages: {
    type: Number,
    required: true,
  },
});

function changePage(item) {
  if (item === "..." || item < 1 || item > props.nbPages) return;
  emits("changePage", item);
}

const pagesToDisplay = computed(() => {
  // Classic display who don't need algo
  if (props.nbPages <= state.maxItem) return props.nbPages;

  // Push current => [4]
  let pages = [props.currentItem];

  // If current is not second to last page push current+1 => [4,5]
  if (props.currentItem < props.nbPages - 1) pages.push(props.currentItem + 1);

  // If current is greater than 2 unshift current-1 => [3,4,5]
  if (props.currentItem > 2) {
    pages.unshift(props.currentItem - 1);
  } else {
    // If current is minus than 2 push current+2 => [3,4,5]
    pages.push(props.currentItem + 2);
  }

  // If current is last page unshift total-2 => [3,4,5]
  if (props.currentItem === props.nbPages) pages.unshift(props.nbPages - 2);

  // If page in second position minus 1 is greater than 2 unshift the previous number or '...' => [2,3,4,5]
  if (pages[1] - 1 > 2)
    pages.unshift(pages[0] - 2 === 1 ? pages[0] - 1 : "...");

  // If current is not equal to 1 unshift 1 => [1,2,3,4,5]
  if (props.currentItem !== 1) pages.unshift(1);

  // If total-2 is greater than current push '...' => [1,2,3,4,5,'...']
  if (props.nbPages - 2 > props.currentItem) pages.push("...");

  // If current is not last push the last => [1,2,3,4,5,'...',8]
  if (props.currentItem < props.nbPages) pages.push(props.nbPages);

  return pages;
});
</script>
